// Shared small components used across the app

export function Pill({ children, bg = 'var(--brand)', color = '#fff', small }) {
  return (
    <span style={{
      display: 'inline-block',
      background: bg,
      color,
      fontSize: small ? '9px' : '10px',
      fontWeight: 700,
      letterSpacing: '0.6px',
      padding: small ? '2px 8px' : '3px 11px',
      borderRadius: '20px',
    }}>
      {children}
    </span>
  );
}

export function SectionHead({ eyebrow, title, subtitle, center = true }) {
  return (
    <div style={{ textAlign: center ? 'center' : 'left', marginBottom: '44px' }}>
      {eyebrow && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: '8px',
          justifyContent: center ? 'center' : 'flex-start',
          marginBottom: '12px',
        }}>
          <span style={{ width: '18px', height: '2px', background: 'var(--brand)', display: 'inline-block' }} />
          <span style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '2.5px', color: 'var(--brand)', textTransform: 'uppercase' }}>
            {eyebrow}
          </span>
          <span style={{ width: '18px', height: '2px', background: 'var(--brand)', display: 'inline-block' }} />
        </div>
      )}
      <h2 style={{ fontSize: 'clamp(22px, 3vw, 34px)', fontWeight: 800, color: typeof title === 'string' ? '#0d1117' : undefined, margin: '0 0 12px' }}>
        {title}
      </h2>
      {subtitle && (
        <p style={{ fontSize: '14px', color: '#6b7a8f', maxWidth: '500px', margin: center ? '0 auto' : '0', lineHeight: 1.7 }}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function Counter({ value, onChange, min = 1 }) {
  return (
    <div style={{ display: 'flex', border: '1.5px solid #e2e8f0', borderRadius: '7px', overflow: 'hidden' }}>
      <button
        onClick={() => onChange(Math.max(min, value - 1))}
        style={{ width: '32px', height: '32px', background: '#f8fafc', border: 'none', fontSize: '16px', fontWeight: 700, color: value <= min ? '#6b7a8f' : '#0d1117' }}
      >−</button>
      <span style={{ width: '38px', textAlign: 'center', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#0d1117' }}>
        {value}
      </span>
      <button
        onClick={() => onChange(value + 1)}
        style={{ width: '32px', height: '32px', background: 'var(--brand)', border: 'none', fontSize: '16px', fontWeight: 700, color: '#fff' }}
      >+</button>
    </div>
  );
}

export function ImgPlaceholder({ height = 140, label, flag, tag, image, gradient = 'linear-gradient(135deg,var(--brand-lt),var(--sec-lt))' }) {
  return (
    <div style={{ 
      height, 
      background: image ? `url(${image}) center/cover no-repeat` : gradient, 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      flexDirection: 'column', 
      gap: 7, 
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Overlay for better text readability on images */}
      {image && <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.15)' }} />}
      
      {!image && (flag
        ? <span style={{ fontSize: '32px' }}>{flag}</span>
        : (
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="var(--brand)" strokeWidth="1.5">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
          </svg>
        )
      )}
      {label && !image && (
        <span style={{ fontSize: '10px', color: '#6b7a8f', fontWeight: 600, letterSpacing: '.8px' }}>{label}</span>
      )}
      {tag && (
        <span style={{ position: 'absolute', top: '10px', left: '10px', fontSize: '9px', fontWeight: 700, padding: '3px 10px', borderRadius: '20px', background: 'var(--secondary)', color: '#0d1117', zIndex: 2 }}>
          {tag}
        </span>
      )}
    </div>
  );
}
